/**
 * Share intent — URL sharer resmi tiap platform.
 *
 * Sengaja memakai URL intent, bukan SDK JS: sharer resmi Facebook/X butuh app
 * id + script pihak ketiga, sedangkan URL intent stabil, tanpa cookie, dan
 * tetap jalan di in-app browser (Instagram, TikTok) yang memblokir script
 * eksternal.
 */

export type ShareTarget = "whatsapp" | "x" | "facebook" | "threads";

/**
 * URL kanonik satu produk.
 *
 * Detail produk bukan route tersendiri — modalnya disinkronkan ke query
 * `?slug=` di /products (lihat openModal di ProductsPage), jadi inilah
 * satu-satunya bentuk URL yang bisa dibuka orang lain dan tetap membuka
 * produk yang benar.
 */
export function productShareUrl(slug: string, origin: string): string {
  return `${origin}/products?slug=${encodeURIComponent(slug)}`;
}

/**
 * Bangun URL intent per platform.
 *
 * `text` adalah kalimat pengantar; `url` selalu ikut terkirim, entah sebagai
 * field terpisah atau ditempel ke teks — tergantung apa yang didukung platform.
 */
export function shareIntentUrl(target: ShareTarget, url: string, text: string): string {
  const encodedUrl = encodeURIComponent(url);
  const encodedText = encodeURIComponent(text);
  // WhatsApp & Threads tidak punya field URL terpisah — link harus menyatu
  // dengan body teks, kalau tidak ia hilang sama sekali.
  const textWithUrl = encodeURIComponent(`${text} ${url}`);

  switch (target) {
    case "whatsapp":
      return `https://wa.me/?text=${textWithUrl}`;
    case "x":
      return `https://twitter.com/intent/tweet?text=${encodedText}&url=${encodedUrl}`;
    case "facebook":
      // Facebook mengabaikan teks/judul yang dikirim lewat query — parameter
      // itu dimatikan sejak 2017. Judul, deskripsi, dan gambar di preview
      // murni dibaca dari tag Open Graph halaman tujuan, jadi hanya `u` yang
      // berguna di sini.
      return `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`;
    case "threads":
      return `https://www.threads.net/intent/post?text=${textWithUrl}`;
  }
}
